import { defineGameCard, onDeath } from '../authoring/index.js';
import { deathController, liveOpposingEnemy } from './furniture_helpers.js';
export const DishSideboardCard = defineGameCard({
    id: 'dish_sideboard',
    gameplay: { type: 'STRUCTURE', cost: 3, baseStats: { attack: 0, health: 5 } },
    presentation: {
        name: 'Сервант с посудой',
        description: 'После гибели возьмите 1 карту. Затем нанесите 2 урона вражеской карте напротив, если она ещё на поле.',
        glyph: {
            colors: ['#10213A', '#351B1F', '#A43D2A', '#833025', '#6F2D27'],
            rows: [
                '...111111111111111..',
                '.122222222222222221.',
                '..1344444444445551..',
                '..1322222442225551..',
                '..1322.524452.2551..',
                '..132...2445...251..',
                '..1322.224455.2251..',
                '..1322222442222251..',
                '..1322.222222.2251..',
                '..132...2442...251..',
                '..1325.524422.2251..',
                '..1325522442222251..',
                '..1322222442255551..',
                '..1344554444444451..',
                '..1344444554444421..',
                '..1354344445434221..',
                '..1354544442222221..',
                '..1222222222222221..',
                '.122222222222222221.',
                '..1111111111111111..',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onDeath((ctx, event) => {
            const controllerId = deathController(ctx, event);
            if (controllerId === undefined)
                return;
            ctx.ops.drawCard(controllerId, 1);
            const opposite = liveOpposingEnemy(ctx, event.cellId, controllerId);
            if (opposite !== undefined) {
                ctx.ops.dealDamage({ kind: 'unit', instanceId: opposite.id }, 2);
            }
        }),
    ],
    ui: { mechanics: ['death'] },
});
//# sourceMappingURL=dish_sideboard.js.map